




















import { Component, Watch, Vue } from 'vue-property-decorator';
import Bubbles from '../components/Bubbles.vue';
@Component({
  components: {
    Bubbles,
  },
})
export default class CookerDome extends Vue {
  /* TODO: Move data to service */
  private data() {
    return {
      backValves: {
        url: require('../assets/home-mech/cooker-dome-back-valves_140x116.png'),
        alt: 'cooker dome back valves',
      },
      mixer: {
        url: require('../assets/home-mech/cooker-dome-mixer_140x116.png'),
        alt: 'cooker dome mixer',
      },
      casing: {
        url: require('../assets/home-mech/cooker-dome-casing_140x116.png'),
        alt: 'cooker dome casing',
      },
    };
  }
 }
